'use client'

import { Dialog, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

export function DemoModal({ isOpen, onClose }) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
      
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="mx-auto max-w-3xl w-full bg-white rounded-2xl shadow-xl">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-semibold text-gray-900">Request Demo</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>
          
          {/* Tally Form iframe container */}
          <div className="p-6">
            <div className="w-full h-[500px] rounded-lg overflow-hidden">
              <iframe
                src="https://tally.so/embed/m6gaoB?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                width="100%"
                height="100%"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Request Demo Form"
                className="rounded-lg"
                allow="camera; microphone; autoplay; encrypted-media;"
              />
            </div>
          </div>
          
          {/* Footer */}
          <div className="px-6 pb-6">
            <p className="text-sm text-gray-500 text-center">
              Fill out the form above and we'll get back to you within 24 hours.
            </p>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}